<div class="lu-ckeditor-formly">
	<div class="lu-ckeditor-formly__wrapper form-control">
		<lu-ckeditor
			[formControl]="formControl | fromAbstractToFormControl"
			(ngModelChange)="change($event)"
			[formlyAttributes]="field"
			[options]="ckeditorOptions"></lu-ckeditor>
	</div>
</div>
